export const ITEMS_PER_PAGE = {
    DEFAULT: 10,
    LARGE: 15,
    EXTRA_LARGE: 20,
} as const;

export const SUPPLIER_STATUS_CODES = {
    OPERATING: 'OPERATING',
    TERMINATION_REQUESTED: 'TERMINATION_REQUESTED',
    READY: 'READY',
    SUSPENDED: 'SUSPENDED',
    TERMINATED: 'TERMINATED',
} as const;

export const SUPPLIER_STATUS_SORT_ORDER: Record<string, number> = {
    [SUPPLIER_STATUS_CODES.OPERATING]: 1,
    [SUPPLIER_STATUS_CODES.TERMINATION_REQUESTED]: 2,
    [SUPPLIER_STATUS_CODES.READY]: 3,
    [SUPPLIER_STATUS_CODES.SUSPENDED]: 4,
    [SUPPLIER_STATUS_CODES.TERMINATED]: 5,
};
